import React from 'react';
import { useSelector } from 'react-redux';

import { selectActiveEventTypeId } from 'features/input/inputSlice';

import EventInputYellowCard from './inputs/EventInputYellowCard';
import EventInputSubstitution from './inputs/EventInputSubstitution';
import EventInputRedCard from './inputs/EventInputRedCard';
import EventInputGoal from './inputs/EventInputGoal';
import EventInputCorner from './inputs/EventInputCorner';
import EventInputOffside from './inputs/EventInputOffside';
import EventInputFreeKick from './inputs/EventInputFreeKick';
import EventInputPenalty from './inputs/EventInputPenalty';
import EventInputPenaltyMiss from './inputs/EventInputPenaltyMiss';
import EventInputDisallowedGoal from './inputs/EventInputDisallowedGoal';

import StyledEventInput from './StyledEventInput';
import { MatchEventType } from '../../enums/matchEventType';
import EventInputPenaltiesGoal from './inputs/EventInputPenaltiesGoal';

//  This component takes care of showing and handling the correct inputs for the selected event type.
const EventInput: React.FC = () => {
  const activeEventTypeId = useSelector(selectActiveEventTypeId);

  let input;

  switch (activeEventTypeId) {
    case MatchEventType.DISALLOWED_GOAL: {
      input = <EventInputDisallowedGoal />;
      break;
    }
    case MatchEventType.GOAL:
    case MatchEventType.OWN_GOAL: {
      input = <EventInputGoal />;
      break;
    }

    case MatchEventType.RED_CARD: {
      input = <EventInputRedCard />;
      break;
    }

    case MatchEventType.YELLOW_CARD: {
      input = <EventInputYellowCard />;
      break;
    }

    case MatchEventType.SECOND_YELLOW_CARD: {
      input = <EventInputYellowCard />;
      break;
    }

    case MatchEventType.PLAYER_OFF: {
      input = <EventInputSubstitution />;
      break;
    }

    case MatchEventType.CORNER: {
      input = <EventInputCorner />;
      break;
    }

    case MatchEventType.OFFSIDE: {
      input = <EventInputOffside />;
      break;
    }

    case MatchEventType.FREE_KICK: {
      input = <EventInputFreeKick />;
      break;
    }

    case MatchEventType.PENALTY:
    case MatchEventType.PENALTIES_PENALTY: {
      input = <EventInputPenalty />;
      break;
    }

    case MatchEventType.PENALTY_MISS:
    case MatchEventType.PENALTIES_MISS: {
      input = <EventInputPenaltyMiss penaltiesShootout={activeEventTypeId === MatchEventType.PENALTIES_MISS} />;
      break;
    }

    case MatchEventType.PENALTIES_GOAL:
      input = <EventInputPenaltiesGoal />;
      break;
  }

  return <StyledEventInput>{input}</StyledEventInput>;
};

export default EventInput;
